export default __webpack_public_path__ + "static/media/logo-cakedefi-2line.74eb343e.svg";